
// Omnix/client/ui/TicketManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class TicketManager extends ComponentBase {
    static styles = `
        .ticket-manager-container {
            display: flex;
            height: 100%;
            overflow: hidden;
        }
        .ticket-index-pane {
            width: 380px;
            min-width: 320px;
            border-right: 1px solid var(--bs-border-color);
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
        }
        .ticket-detail-pane {
            flex-grow: 1;
        }
        @media (max-width: 768px) {
            .ticket-manager-container.viewing-detail .ticket-index-pane {
                display: none;
            }
            .ticket-manager-container:not(.viewing-detail) .ticket-detail-pane {
                display: none;
            }
            .ticket-index-pane, .ticket-detail-pane {
                width: 100%;
                border-right: none;
            }
        }
    `;

    constructor(config) {
        super(config);
        this.selectedTicketId = null;
        this.isDetailViewVisible = false;
        this.applyStyles();
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'ticket-manager-container';

        this.indexView = await this.createManagedComponent('TicketIndexView', null, {
            instanceId: `${this.config.instanceId}-index`
        });
        this.detailView = await this.createManagedComponent('TicketDetailView', null, {
            instanceId: `${this.config.instanceId}-detail`
        });

        this.indexView.on('ticketSelected', (e) => this.handleTicketSelected(e.ticketId));
        this.detailView.on('closeDetail', () => this.handleCloseDetail());
        this.indexView.on('newTicket', () => this.handleNewTicket());


        this.ticketForm = await this.createManagedComponent('TicketForm', null, {
            instanceId: `${this.config.instanceId}-form`
        });
        this.ticketForm.on('ticketSaved', async () => {
            await this.indexView.loadTickets();
            if (this.selectedTicketId) {
                await this.detailView.loadTicket();
            }
        });

        await super.initialize();
    }

    async initAfterLogin() {
        try {
            // --- START OF FIX ---
            // Fetch both contacts AND assignable agents (which are users) in parallel.
            const [contactsResult, agentsResult] = await Promise.all([
                this.appClient.rpcClient.call('OmniContactsRpc.getData', { pageSize: 1000 }),
                this.appClient.rpcClient.call('UnifiedInboxRpc.getAssignableAgents', {})
            ]);
            this.allProjectContacts = contactsResult.data || [];
            this.assignableAgents = agentsResult || [];

            // Pass BOTH lists to the detail view.
            this.detailView.allProjectContacts = this.allProjectContacts;
            this.detailView.assignableAgents = this.assignableAgents;
            // --- END OF FIX ---
        } catch (error) {
            this.log.error("Failed to load initial data for TicketManager:", error);
        }
    }


    async refresh() {
        const queryParams = this.appClient.layoutEngine.getQueryParams();
        const ticketIdFromUrl = queryParams.ticketId;

        if (ticketIdFromUrl && ticketIdFromUrl !== this.selectedTicketId) {
            this.log.info(`TicketManager shown with ticketId in URL: ${ticketIdFromUrl}. Selecting ticket.`);
            this.handleTicketSelected(ticketIdFromUrl);
        }
    }


    handleTicketSelected(ticketId) {
        this.selectedTicketId = ticketId;
        this.isDetailViewVisible = true;
        this.detailView.setTicket(ticketId);
        this.updateLayout();
    }


    handleCloseDetail() {
        this.selectedTicketId = null;
        this.isDetailViewVisible = false;
        this.detailView.setTicket(null);
        this.updateLayout();
    }

    async handleNewTicket() {
        this.ticketForm.show('create', { status: 'new', priority: 'normal' }, this.assignableAgents, this.allProjectContacts);
    }


    updateLayout() {
        this.container.classList.toggle('viewing-detail', this.isDetailViewVisible);
    }

    async render() {
        this.container.innerHTML = '';

        const indexPane = document.createElement('div');
        indexPane.className = 'ticket-index-pane';
        indexPane.appendChild(await this.indexView.render());

        const detailPane = document.createElement('div');
        detailPane.className = 'ticket-detail-pane';
        detailPane.appendChild(await this.detailView.render());

        this.container.appendChild(indexPane);
        this.container.appendChild(detailPane);

        return this.container;
    }
}